import Http, { Response } from '@rootCommon/services/http';
import { Filters } from '@rootCommon/types/filter';
import { IdType } from '@rootCommon/types/common';

export default class CrudRequest<T, D> extends Http {
  constructor(private readonly endPoint: string) {
    super();
    this.getList = this.getList.bind(this);
    this.getById = this.getById.bind(this);
    this.create = this.create.bind(this);
    this.update = this.update.bind(this);
    this.delete = this.delete.bind(this);
  }

  getList = async (filters?: Filters, siteId?: IdType): Promise<T[]> => {
    let params = {} as Filters;

    if (filters) params = { ...filters };
    if (siteId) params.siteId = siteId;

    const res = await CrudRequest.get<T[]>(`${this.endPoint}/all`, { params });
    return CrudRequest.handlerResponse<T[]>(res);
  };

  getById = async (id: number): Promise<T> => {
    const res = await CrudRequest.get<T>(this.endPoint, { params: { id } });
    return CrudRequest.handlerResponse<T>(res);
  };

  create = async (data: D): Promise<T> => {
    const res = await CrudRequest.post<T, D>(this.endPoint, data);
    return CrudRequest.handlerResponse<T>(res);
  };

  update = async (id: number, data: D): Promise<T> => {
    const res = await CrudRequest.put<T, D>(this.endPoint, data, { params: { id } });
    return CrudRequest.handlerResponse<T>(res);
  };

  delete = async (id: number): Promise<void> => {
    const res = await CrudRequest.delete<void>(this.endPoint, { params: { id } });
    return CrudRequest.handlerResponse<void>(res);
  };

  private static handlerResponse<R>(res: Response<R>): R {
    return res.data;
  }
}
